import axios from 'axios';
import {
  IUserDeleteResponse,
  IUserGetRequest,
  IUserGetResponse,
  IUserPostRequest,
  IUserPostResponse,
  IUsersGetResponse,
  IUsersParams,
} from '../model/usersModel';

export const usersApi = {
  getAll: () => axios.get<IUsersGetResponse[]>('/api/users'),
  post: (data: IUserPostRequest) => axios.post<IUserPostResponse>('/api/users', data),
  getOne: (params: IUserGetRequest) => axios.get<IUserGetResponse>(`/api/users/${params.id}`),
  delete: (params: IUsersParams) => axios.delete<IUserDeleteResponse>(`/api/users/${params.id}`),
};
